import { createSelector } from 'reselect'

import { selectComposedReportState } from './selectComposedReportState'

export const selectIsOpenScopeEditor = createSelector(
  [selectComposedReportState],
  ({ isOpenScopeEditor }) => isOpenScopeEditor
)
